import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { PageHomeComponent } from './views/page-home/page-home.component';
import { PageSobreComponent } from './views/page-sobre/page-sobre.component';
import { PageAtuacaoComponent } from './views/page-atuacao/page-atuacao.component';
import { PageContatoComponent } from './views/page-contato/page-contato.component';
import { PageEducacaoTecnologicaComponent } from './views/page-educacao-tecnologica/page-educacao-tecnologica.component';
import { PageEmpreendedorismoInovacaoComponent } from './views/page-empreendedorismo-inovacao/page-empreendedorismo-inovacao.component';
import { PageCulturaColaborativaComponent } from './views/page-cultura-colaborativa/page-cultura-colaborativa.component';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';
import { PageApoioCulturalComponent } from './views/page-apoio-cultural/page-apoio-cultural.component';
import { PageComoIncubarSuaEmpresaComponent } from './views/page-como-incubar-sua-empresa/page-como-incubar-sua-empresa.component';
const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    component: PageLayoutComponent,
    children: [
      { path: 'home', component: PageHomeComponent },
      { path: 'sobre', component: PageSobreComponent },
      // { path: 'atuacao', component: PageAtuacaoComponent },
      { path: 'contato', component: PageContatoComponent },

      {
        path: 'educacao-tecnologica',
        component: PageEducacaoTecnologicaComponent,
      },
      {
        path: 'empreendedorismo-inovacao',
        component: PageEmpreendedorismoInovacaoComponent,
      },
      {
        path: 'cultura-colaborativa',
        component: PageCulturaColaborativaComponent,
      },
      {
        path: 'apoio-cultural',
        component: PageApoioCulturalComponent,
      },
      {
        path: 'incubar-empresa',
        component: PageComoIncubarSuaEmpresaComponent,
      }
    ],
  },
  { path: '**', component: PageNotFoundComponent },
  // { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
